import React from 'react'
import ProductCardDetail from '../components/ProductCardDetail'

function ProductDetailPage() {
  return (
    <div className='bg-[#272629]'>
      <ProductCardDetail/>
    </div>
  )
}

export default ProductDetailPage
